import { FIELD_TYPES } from "features/MediationForm/validationSchema";



export const mediationFormConfig = [
  // ── Section 1: Plaintiff Details ──────────────────────────────────────────
  {
    sectionId: "claimant",
    sectionTitle: "Claimant Details",
    sectionSubtitle: "Information about the party initiating the mediation",
    fields: [
      {
        id: "claimant_name",
        label: "Full Name",
        type: FIELD_TYPES.TEXT,
        placeholder: "Enter full legal name",
        required: true,
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "claimant_email",
        label: "Email Address",
        type: FIELD_TYPES.EMAIL,
        placeholder: "example@domain.com",
        required: false,
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "claimant_mobile",
        label: "Mobile Number",
        type: FIELD_TYPES.TEL,
        placeholder: "98XXX XXXXX",
        required: true,
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "claimant_company_name",
        label: "Company Name",
        type: FIELD_TYPES.TEXT,
        placeholder: "Company name (if applicable)",
        required: false,
        helperText: "",
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "claimant_address",
        label: "Address",
        type: FIELD_TYPES.TEXTAREA,
        placeholder: "Enter full address including city, state and PIN code",
        required: true,
        rows: 3,
        gridSize: { xs: 12 },
      },
      {
        id: "claimant_company_details",
        label: "Company Details",
        type: FIELD_TYPES.TEXTAREA,
        placeholder:
          "Describe the company — name, address, registration number, etc. (if applicable)",
        required: false,
        rows: 3,
        gridSize: { xs: 12 },
      },
    ],
  },

  // ── Section 2: respondent Details ─────────────────────────────────────────
  {
    sectionId: "respondent",
    sectionTitle: "Respondent Details",
    sectionSubtitle: "Information about the opposing party in the dispute",
    fields: [
      {
        id: "respondent_name",
        label: "Full Name",
        type: FIELD_TYPES.TEXT,
        placeholder: "Enter full legal name",
        required: true,
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "respondent_email",
        label: "Email Address",
        type: FIELD_TYPES.EMAIL,
        placeholder: "example@domain.com",
        required: false,
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "respondent_mobile",
        label: "Mobile Number",
        type: FIELD_TYPES.TEL,
        placeholder: "98XXX XXXXX",
        required: true,
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "respondent_company_name",
        label: "Company Name",
        type: FIELD_TYPES.TEXT,
        placeholder: "Company name (if applicable)",
        required: false,
        helperText: "",
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "respondent_address",
        label: "Address",
        type: FIELD_TYPES.TEXTAREA,
        placeholder: "Enter full address including city, state and PIN code",
        required: true,
        rows: 3,
        gridSize: { xs: 12 },
      },
      {
        id: "respondent_company_details",
        label: "Company Details",
        type: FIELD_TYPES.TEXTAREA,
        placeholder:
          "Describe the company — name, address, registration number, etc. (if applicable)",
        required: false,
        rows: 3,
        gridSize: { xs: 12 },
      },
    ],
  },

  // ── Section 3: Relevant Documents ────────────────────────────────────────
  {
    sectionId: "documents",
    sectionTitle: "Relevant Documents",
    sectionSubtitle:
      "Upload any supporting documents related to the dispute",
    fields: [
      {
        id: "relevant_documents",
        label: "Upload Documents",
        type: FIELD_TYPES.FILE_UPLOAD,
        accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
        multiple: true,
        required: false,
        helperText: "Accepted formats: PDF, DOC, DOCX, JPG, PNG (max 10MB each)",
        gridSize: { xs: 12 },
      },
    ],
  },

  // ── Section 4: Mediation Details ─────────────────────────────────────────
  {  
    sectionId: "mediation",
    sectionTitle: "Mediation Details",
    sectionSubtitle: "Provide details about the nature and context of the dispute",
    fields: [
      {
        id: "dispute_summary",
        label: "Summary of Dispute",
        type: FIELD_TYPES.TEXTAREA,
        placeholder:
          "Briefly describe the nature of the dispute, key events, and what resolution you are seeking...",
        required: true,
        maxLength: 1000,
        rows: 5,
        gridSize: { xs: 12 },
      },
      {
        id: "preferred_language",
        label: "Preferred Language for Mediation",
        type: FIELD_TYPES.SELECT,
        required: true,
        options: [
          { value: "english", label: "English" },
          { value: "hindi", label: "Hindi" },
          { value: "marathi", label: "Marathi" },
          { value: "bengali", label: "Bengali" },
          { value: "tamil", label: "Tamil" },
          { value: "telugu", label: "Telugu" },
          { value: "kannada", label: "Kannada" },
          { value: "gujarati", label: "Gujarati" },
          { value: "punjabi", label: "Punjabi" },
          { value: "other", label: "Other" },
        ],
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "resolution_timeline",
        label: "Preferred Timeline for Resolution",
        type: FIELD_TYPES.SELECT,
        required: true,
        options: [
          { value: "30_days", label: "Within 30 Days" },
          { value: "60_days", label: "Within 60 Days" },
          { value: "90_days", label: "Within 90 Days" },
          { value: "6_months", label: "Within 6 Months" },
          { value: "flexible", label: "Flexible / No Preference" },
        ],
        gridSize: { xs: 12, sm: 6 },
      },
      {
        id: "court_pending",
        label: "Is the dispute currently pending before any court of law or tribunal?",
        type: FIELD_TYPES.RADIO,
        required: true,
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        gridSize: { xs: 12 },
      },
      {
        id: "court_details",
        label: "Court / Tribunal Details",
        type: FIELD_TYPES.TEXTAREA,
        placeholder:
          "Please provide the name of the court or tribunal, case number, next date of hearing, and current stage of proceedings...",
        required: false,
        rows: 4,
        dependsOn: { field: "court_pending", value: "yes" },
        gridSize: { xs: 12 },
      },
    ],
  },

  // {
  //   sectionId: "counsel",
  //   sectionTitle: "Counsel / Legal Representative",
  //   sectionSubtitle: "Details of your legal representative, if any",
  //   fields: [
  //     {
  //       id: "counsel_name",
  //       label: "Counsel Name",
  //       type: FIELD_TYPES.TEXT,
  //       placeholder: "Advocate / Firm name",
  //       required: false,
  //       gridSize: { xs: 12, sm: 6 },
  //     },
  //     {
  //       id: "counsel_email",
  //       label: "Counsel Email",
  //       type: FIELD_TYPES.EMAIL,
  //       placeholder: "counsel@firm.com",
  //       required: false,
  //       gridSize: { xs: 12, sm: 6 },
  //     },
  //     {
  //       id: "bar_registration",
  //       label: "Bar Council Registration Number",
  //       type: FIELD_TYPES.TEXT,
  //       placeholder: "e.g. MH/1234/2010",
  //       required: false,
  //       gridSize: { xs: 12, sm: 6 },
  //     },
  //   ],
  // },
];
